import {useEffect} from 'react';

import {Asset} from '@deviceinsight/ng-ui-api-client';

import KpiSingleValueColumnWidgetConfigContent from './KpiSingleValueColumnWidgetConfigContent';
import {KpiSingleValueColumnWidgetConfigProps} from '../types';
import ResourcesProvider from '../../common/ResourcesProvider';
import {validateKpiWidgetTimeConfig} from '../../common/kpiUtils';
import {useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';

const KpiSingleValueColumnWidgetConfig = ({
	config,
	config: {settings},
	context,
	onChangeConfig,
	setApplyButtonDisabled
}: KpiSingleValueColumnWidgetConfigProps) => {
	const {
		kpiName,
		assetUrn,
		periodTimeframe,
		periodType,
		workingShiftEnabled,
		workingShiftDays,
		workingShiftTimeFrom,
		workingShiftTimeTo
	} = settings;
	const {t} = useTranslation();
	useEffect(() => {
		const missingAsset = context.type === 'assetGroup' && !assetUrn;
		const missingKpiName = !kpiName;
		const invalidConfiguration = !validateKpiWidgetTimeConfig(
			periodTimeframe,
			periodType,
			workingShiftEnabled,
			workingShiftDays,
			workingShiftTimeFrom,
			workingShiftTimeTo
		);
		const invalidMessage = missingAsset
			? t('dashboard.widgets.kpi.invalid.missingAsset', {defaultValue: 'Missing Asset'})
			: missingKpiName
			? t('dashboard.widgets.kpi.addKpi.invalid.missingKpi', {defaultValue: 'Missing KPI'})
			: invalidConfiguration
			? t('dashboard.widgets.kpi.addKpi.invalid.invalidConfiguration', {defaultValue: 'Invalid Configuration'})
			: undefined;
		const invalid = !!invalidMessage;

		setApplyButtonDisabled(invalid);
	}, [
		t,
		assetUrn,
		context.type,
		kpiName,
		periodTimeframe,
		periodType,
		workingShiftEnabled,
		workingShiftDays,
		workingShiftTimeFrom,
		workingShiftTimeTo,
		setApplyButtonDisabled
	]);

	const handleAssetSelect = (asset: Asset) => {
		onChangeConfig({...config, settings: {...settings, assetUrn: asset.urn}});
	};

	const handleKpiNameSelect = (name: string | null | undefined) => {
		onChangeConfig({...config, settings: {...settings, kpiName: name}});
	};

	return (
		<ResourcesProvider
			assetGroup={context.type === 'assetGroup' ? context.assetGroup : null}
			onAssetSelect={handleAssetSelect}
			onKpiNameSelect={handleKpiNameSelect}>
			{(setAssetSelecting, setKpiNameSelecting) => (
				<KpiSingleValueColumnWidgetConfigContent
					context={context}
					config={config}
					onChangeConfig={onChangeConfig}
					setSelectingAsset={() => setAssetSelecting(0)}
					setSelectingKpi={(assetUrn: string) => setKpiNameSelecting(0, assetUrn)}
				/>
			)}
		</ResourcesProvider>
	);
};

export default KpiSingleValueColumnWidgetConfig;
